import { Foreground } from '@front/sharedcomponents/Styles';
import { MessageBoxType } from '@shared/utils/Interfaces/Screens/MessageBox.types';
import { SoundManager } from '@shared/utils/SoundManager';
import { SvgIconType } from '../../elements/SvgIcon/SvgIconType';
export function getMessageBoxIcon(type) {
    switch (type) {
        case MessageBoxType.Error:
        case MessageBoxType.Warning:
            return SvgIconType.MenuError;
        case MessageBoxType.Question:
            return SvgIconType.Question;
        case MessageBoxType.Approve:
            return SvgIconType.Accept;
        case MessageBoxType.YellowInfo:
        case MessageBoxType.Info:
        default:
            return SvgIconType.InfoTool;
    }
}
export function getIconColorByMessageType(type) {
    switch (type) {
        case MessageBoxType.Error:
            return Foreground.Negative;
        case MessageBoxType.Approve:
            return Foreground.Positive;
        case MessageBoxType.Warning:
        case MessageBoxType.YellowInfo:
            return Foreground.PrimaryData;
        case MessageBoxType.Info:
        default:
            return Foreground.Secondary;
    }
}
export function playMessageBoxAlertSound(type) {
    let soundKey = null;
    switch (type) {
        case MessageBoxType.Error:
        case MessageBoxType.Warning:
        case MessageBoxType.Info:
        case MessageBoxType.Question:
            soundKey = SoundManager.SoundKeys.Warning;
            break;
        default:
            soundKey = SoundManager.SoundKeys.Confirmation;
    }
    SoundManager.tryPlaySound(soundKey);
}
